// „Passwort vergessen?" — Link per Mail anfordern.
//
// Die Antwort ist immer dieselbe, ob es das Konto gibt oder nicht: sonst ließe
// sich hier durchprobieren, welche Namen und Adressen bei LagerPro existieren.
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api, ApiFehler } from '../../../gemeinsam/lib/api';
import { useSprache } from '../../../gemeinsam/lib/i18n';
import { Feld, Hinweis, Knopf } from '../../../gemeinsam/komponenten/Basis';
import AuthRahmen from '../komponenten/AuthRahmen';

export default function PasswortVergessen() {
  const { t } = useSprache();
  const [kennung, setKennung] = useState('');
  const [laedt, setLaedt] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);
  const [minuten, setMinuten] = useState<number | null>(null);

  async function absenden(e: React.FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLaedt(true);
    try {
      const r = await api<{ gueltigMinuten: number }>('/auth/passwort-vergessen', { methode: 'POST', daten: { kennung: kennung.trim() } });
      setMinuten(r.gueltigMinuten);
    } catch (e) {
      setFehler(e instanceof ApiFehler ? e.message : t('anmelden.fehler'));
    } finally { setLaedt(false); }
  }

  const zurueck = (
    <Link to="/anmelden" className="block text-center text-sm font-medium text-marke-600 hover:underline dark:text-marke-400">
      {t('passwort.zurAnmeldung')}
    </Link>
  );

  if (minuten !== null) {
    return (
      <AuthRahmen>
        <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100">{t('passwort.gesendetTitel')}</h1>
        <Hinweis art="erfolg">{t('passwort.gesendetText').replace('{min}', String(minuten))}</Hinweis>
        {zurueck}
      </AuthRahmen>
    );
  }

  return (
    <AuthRahmen>
      <form onSubmit={absenden} className="space-y-4">
        <div>
          <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100">{t('passwort.vergessenTitel')}</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{t('passwort.vergessenText')}</p>
        </div>
        {fehler && <Hinweis art="fehler">{fehler}</Hinweis>}
        <Feld label={t('anmelden.kennung')} value={kennung} onChange={e => setKennung(e.target.value)}
              autoComplete="username" autoFocus required />
        <Knopf type="submit" variante="primaer" laedt={laedt} disabled={!kennung.trim()} className="w-full">
          {t('passwort.linkSenden')}
        </Knopf>
      </form>
      {zurueck}
    </AuthRahmen>
  );
}
